import { defineStore } from 'pinia'
import type { Token } from '@/types';
import { KEY_TOKEN, getAccessToken, getRefreshToken } from '@/utils/authHeader';

export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      loggedIn: false,
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken(),
    }
  },
  actions: {
    setToken(newToken: Token) {
      this.accessToken = newToken.access
      this.refreshToken = newToken.refresh
      localStorage.setItem(KEY_TOKEN, JSON.stringify(newToken))
    },
    clearToken() {
      this.accessToken = null
      this.refreshToken = null
      localStorage.setItem(KEY_TOKEN, '')
      this.router.push({ name: 'login' })
    },
  }
})
